<tui-root>
  <log-content></log-content>
  <router-outlet></router-outlet>
</tui-root>
